import type { Insurance, InsuranceType } from '@optionway/models';
import { InsuranceTypeEnum } from '@optionway/models';

interface SelectedInsuranceStore {
  insurance?: Insurance;
}

export const useSelectedInsuranceStore = defineStore('selected-insurance', {
  state: (): SelectedInsuranceStore => ({
    insurance: undefined,
  }),
  getters: {
    knownInsuranceType(): InsuranceType | undefined {
      const type = this.insurance?.type;
      return type === InsuranceTypeEnum.CANCEL || type === InsuranceTypeEnum.MULTI_RISK ? type : undefined;
    },
  },
  actions: {
    select(insurance?: Insurance) {
      const previous = this.insurance;
      this.insurance = insurance;
      useGtmStore().trackInsuranceChange(previous, insurance);
    },
  },
});
